import { render } from "./MassMediaSmtk.vue?vue&type=template&id=15aeedf4&scoped=true"
import script from "./MassMediaSmtk.vue?vue&type=script&lang=js"
export * from "./MassMediaSmtk.vue?vue&type=script&lang=js"

import "./MassMediaSmtk.vue?vue&type=style&index=0&id=15aeedf4&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15aeedf4"]])

export default __exports__